import React, { useEffect, useMemo } from 'react';
import { Typography } from '@mui/material';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';
import { getDealClientId } from '@/features/deals/helper';
import { useGetRelationshipCompanyQuery } from '@/features/relationshipCompanies/relationshipCompaniesApi';

export const DataGridTaskContactName = ({ row }) => {
	const { dealId, clientId, contactName: rowContactName } = row;

	const { data: dealData, isLoading: isLoadingDeal } = useGetDealRowQuery(dealId, {
		skip: !dealId,
	});

	const resolvedClientId = clientId ?? getDealClientId(dealData);

	const { data: clientData, isLoading: isLoadingClient } = useGetClientRowQuery(
		resolvedClientId,
		{
			skip: !resolvedClientId,
		},
	);

	const { data: relationshipCompanyData, isLoading: isLoadingRelationshipCompany } =
		useGetRelationshipCompanyQuery(row?.relationshipCompanyId, {
			skip: !row?.relationshipCompanyId,
		});

	const contactName =
		rowContactName?.trim() ||
		relationshipCompanyData?.contactName ||
		clientData?.contactName ||
		dealData?.contactName ||
		(isLoadingClient || isLoadingDeal || isLoadingRelationshipCompany ? 'Loading...' : '-');

	return <Typography>{contactName}</Typography>;
};
